export default {
    path: '/',
    name: 'home',
    redirect: '/dashboard',
}
